<template>
  <div class="horizbox">
    <el-row type="flex" class="row-bg" style="margin-bottom:10px;">
      <el-col :xs="24">
        <el-button type="primary" @click="fetch">刷新</el-button>
      </el-col>
    </el-row>

    <el-table class="table" :data="monthData" border size="small" style="width:100%">
      <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
      <el-table-column label="年月" width="100">
        <template #default="scope">{{ formatMonth( getVal(scope.row, 'MonthDate', '年月') ) }}</template>
      </el-table-column>
      <el-table-column label="销售数" width="100" align="right">
        <template #default="scope">{{ getVal(scope.row, 'SaleNumber', '销售数') }}</template>
      </el-table-column>
      <el-table-column label="销售采购价" width="120" align="right">
        <template #default="scope">{{ fmtMoney( getVal(scope.row, 'SalePurchasePrice', '销售采购价') ) }}</template>
      </el-table-column>
      <el-table-column label="销售货品成本" width="120" align="right">
        <template #default="scope">{{ fmtMoney( getVal(scope.row, 'SaleProductPrice', '销售货品成本') ) }}</template>
      </el-table-column>

      <el-table-column label="月度日均库存数" width="140" align="right">
        <template #default="scope">{{ fmtNumber( getVal(scope.row, 'AvgDayRemain', '月度日均库存数') ) }}</template>
      </el-table-column>
      <el-table-column label="月度日均货品总成本" width="160" align="right">
        <template #default="scope">{{ fmtMoney( getVal(scope.row, 'AvgProductPrice', '月度日均货品总成本') ) }}</template>
      </el-table-column>
      <el-table-column label="月度日均金重" width="120" align="right">
        <template #default="scope">{{ fmtNumber( getVal(scope.row, 'AvgGoldWeight', '月度日均金重') ) }}</template>
      </el-table-column>

      <el-table-column label="月度金额周转率(%)" width="140" align="center">
        <template #default="scope">{{ getVal(scope.row, 'MonthAmountTurnoverRate', '月度金额周转率') }}</template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'MonthSaleRemain',
  data() {
    return {
      monthData: []
    }
  },
  methods: {
    fetch() {
      request({ url: '/StockStore/MonthSaleRemain', method: 'get' }).then(res => {
        this.monthData = res.data || []
      }).catch(() => {
        this.$message.error('获取数据失败');
      })
    },
    formatMonth(val) {
      if (!val) return ''
      // val like 202501 or already formatted
      const s = String(val)
      if (s.length === 6) return s.substring(0,4) + '-' + s.substring(4,6)
      return val
    },
    getVal(row, enKey, cnKey) {
      if (!row) return ''
      if (row[enKey] !== undefined && row[enKey] !== null) return row[enKey]
      if (row[cnKey] !== undefined && row[cnKey] !== null) return row[cnKey]
      return ''
    },
    fmtMoney(v) {
      return v == null || v === '' ? '-' : this.$util.fmtMoney(v)
    },
    fmtNumber(v) {
      if (v == null || v === '') return '-'
      if (typeof v === 'number') return v.toFixed(2)
      const n = Number(v)
      return isNaN(n) ? v : n.toFixed(2)
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.horizbox { padding: 0; }
.row-bg { padding: 10px; background:#fff; border-radius:4px; box-shadow: 0 2px 12px rgba(0,0,0,0.05); }
</style>
